/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:01:15
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-16 14:57:45
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/LongCanvas/index.tsx
 */
import React from 'react';

import _LongCanvas from 'src/components/Modules/LongCanvas';

import ContentGroupHOC from '../HOC';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
import { compose } from 'redux';

const LongCanvas = (props) => {
  const {
    //staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnAdd,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
    disabled,
  } = props || {};

  return (
    <_LongCanvas
      linkModules={dynamicData}
      onItemDelete={handleOnItemDelete}
      onItemAdd={handleItemOnAdd}
      onItemChange={handleItemOnChange}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      linkSet={linkSet}
      specificError={specificError}
      droppableId={droppableId}
      disabled={disabled}
    />
  );
};
export default compose(DataHOC, ContentGroupHOC)(LongCanvas);
